export const useRequireLogin = () => {
  const { isGuestUser } = useAuth()

  const requireLoginBefore = async (callback: () => void | Promise<void>) => {
    if (isGuestUser.value) {
      await navigateTo('/login')
      return
    }
    await callback()
  }

  return {
    requireLoginBefore,
  }
}
